import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  headers: { 'Content-Type': 'application/json' },
});

// إضافة التوكن لكل طلب تلقائياً
API.interceptors.request.use((config) => {
  const token = localStorage.getItem('zabtat_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// معالجة أخطاء الـ 401
API.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem('zabtat_token');
      localStorage.removeItem('zabtat_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default API;
